import { render, staticRenderFns } from "./PhieuThongTinNhanPhong.vue?vue&type=template&id=62b1fd92&scoped=true&"
import script from "./PhieuThongTinNhanPhong.vue?vue&type=script&lang=js&"
export * from "./PhieuThongTinNhanPhong.vue?vue&type=script&lang=js&"
import style0 from "./PhieuThongTinNhanPhong.vue?vue&type=style&index=0&id=62b1fd92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b1fd92",
  null
  
)

export default component.exports